import { render, staticRenderFns } from "./FuneralCostComponent.vue?vue&type=template&id=76f6a018&scoped=true&"
import script from "./FuneralCostComponent.vue?vue&type=script&lang=js&"
export * from "./FuneralCostComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f6a018",
  null
  
)

export default component.exports